import { colors } from '@flowwai-frontend/shared/style-guide'

export const notificationsThemes = {
   light: {
      common: {
         titleColor: 'text-gray-900',
         borderColor: 'border-b-gray-300',
         backgroundColor: 'bg-white',
         refreshIconBg: '!bg-white',
         refreshIconColor: colors['gray-700'],
         filterIconStrokeColor: colors['base-white']
      },
      body: {
         bodyBgColor: 'bg-gray-100'
      },
      markAllAsRead: {
         iconColor: colors['gray-600'],
         disabledIconColor: colors['gray-300'],
         buttonBackgroundColor: '!bg-transparent',
         filteredByTextColor: 'text-gray-600'
      },
      notificationCard: {
         cardBgColor: 'bg-base-white',
         cardBorderColor: 'border-gray-300',
         transparentBorderColor: 'border-transparent',
         unReadNotificationCardBgColor: 'bg-gray-50',
         buttonBgColor: '!bg-transparent',
         titleColors: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         readDateTimeColor: 'text-gray-500',
         unReadDateTimeColor: 'text-primary-600',
         notificationIconColor: colors['gray-500']
      },
      notificationsTypeIcons: {
         awPipelineItemNotFound: {
            bgColor: 'bg-violet-100',
            iconColor: colors['violet-600']
         },
         mergePipelineItems: {
            bgColor: 'bg-primary-100',
            iconColor: colors['primary-600']
         },
         missedCall: {
            bgColor: 'bg-error-100',
            iconColor: colors['error-600']
         },
         pipelineItemAssigneeUpdate: {
            bgColor: 'bg-gray-100',
            iconColor: colors['gray-600']
         },
         pipelineItemRemainder: {
            bgColor: 'bg-orange-100',
            iconColor: colors['orange-600']
         },
         defaultNotification: {
            bgColor: 'bg-gray-100',
            iconColor: colors['gray-600']
         },
         pipelineItemsExportFailed: {
            bgColor: 'bg-error-100',
            iconColor: colors['error-600']
         },
         pipelineItemsExportSuccess: {
            bgColor: 'bg-success-100',
            iconColor: colors['success-600']
         },
         pipelineItemSchedule: {
            bgColor: 'bg-primary-100',
            iconColor: colors['primary-600']
         }
      }
   },
   dark: {}
}
